import React from 'react'

const NavigationDots = ({ active }) => {
  return (
    <div className='app__navigation'>
      {['home', 'about', 'work', 'skills', 'contact'].map((item, index) => (
        <a
          href={`#${item}`}
          aria-label={item}
          key={item + index}
          className='app__navigation-dot'
          style={active === item ? { backgroundColor: '#313BAC' } : {}}
        >
          {/* Add this span to satisfy the linter/accessibility */}
          <span className='sr-only' style={{ display: 'none' }}>
            {item}
          </span>
        </a>
      ))}
    </div>
  )
}

export default NavigationDots
